import template from "./pCasemanTeamProcessConfig.html";

export function pCasemanTeamProcessConfigDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCasemanTeamProcessConfigController,
    controllerAs: 'pCasemanTeamProcessConfig',
    bindToController: true
  };

  return directive;
}

class pCasemanTeamProcessConfigController {
  constructor($scope, $location, $interval, $routeParams, $q, Auth, Caseman, Notes, Sort, ConnectionQuality) {
    'ngInject';
    this.$scope = $scope;
    this.$location = $location;
    this.$interval = $interval;
    this.$routeParams = $routeParams;
    this.$q = $q;
    this.Auth = Auth;
    this.Caseman = Caseman;
    this.Notes = Notes;
    this.Sort = Sort;
    this.ConnectionQuality = ConnectionQuality;
    this.state = "loading";
    this.processGroupId = this.$routeParams.processGroupId;
    this.processGroupName = decodeURIComponent(this.$routeParams.processGroupName);
    this.CasemanSubcodeId = this.$routeParams.jobCodeId;
    this.CasemanJobcodeCountry = this.$routeParams.country;

    this.headers = [
      {name: "CASEMAN.PROCESS_KLIX", class: "table-info"},
      {name: "CASEMAN.SUBCODE_CASEMAN", class: "table-caseman"},
    ];

    this.Auth.authorize().then(
      (user) => {
        this.user = user;

        //Notes...
        const timeout = this.$interval(() => { this.notes = this.Notes.getNotes();}, 200);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout );});

        let promises = [
          this.Caseman.getPgProcesses(this.processGroupId),
          this.Caseman.getPgProcessesMappers(this.processGroupId),
        ];

        this.$q.all(promises).then(
          (success) => {
            this.processesKlix = success[0].data.sort(this.Sort.abcBy("name"));
            this.processesMapper = success[1].data;

            this.mapperToDisplay = this.processesKlix && this.processesKlix.map( pKlix => {
              let client = this.processesMapper && this.processesMapper.find(pMapper => pMapper.processId == pKlix.id);
              if(!client) {
                client = {processId: pKlix.id , processName: pKlix.name, subCodeId: null, subCodeName: null, unmatched: true};
              }
              return client;
            });

            this.state = "loaded";
          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  backToPGs() {
    window.history.back();
  }

}